import { Directive, ElementRef, HostBinding, Input, inject } from "@angular/core";

@Directive({ selector: "[stagesDragScrollItem]" })
export class DragScrollItemDirective {
	@HostBinding("style.display")
	display = "inline-block";

	// TODO: Skipped for migration because:
	//  Accessor inputs cannot be migrated as they are too complex.
	@Input("drag-disabled")
	get dragDisabled(): boolean {
		return this._dragDisabled;
	}

	set dragDisabled(value: boolean) {
		this._dragDisabled = value;
	}

	_dragDisabled = false;

	_elementRef: ElementRef;

	constructor() {
		const elementRef = inject<ElementRef>(ElementRef);

		this._elementRef = elementRef;
	}
}
